module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrapper"
    }
  }, [_c('div', {
    staticClass: "gray-bg",
    attrs: {
      "id": "page-wrapper"
    }
  }, [_c('nav', {
    staticClass: "navbar navbar-fixed-top",
    attrs: {
      "role": "navigation"
    }
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('router-link', {
    staticClass: "navbar-minimalize minimalize-styl-2 btn btn-primary",
    attrs: {
      "to": {
        name: 'dashboard'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-in"
  }), _vm._v(" Go to Dashboard\n          ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "wrapper border-bottom white-bg page-heading"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "margin-80"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5 col-lg-5"
  }, [_c('p', {
    staticClass: "invoice-due complete"
  }, [_vm._v("RECIPIENT CREATED TAX INVOICE")]), _vm._v(" "), _c('h1', {
    staticClass: "text-right xero-number"
  }, [_vm._v(_vm._s(_vm.paymentDecorated.xero_number))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper wrapper-content"
  }, [_c('ul', {
    staticClass: "nav nav-actions"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": _vm.downloadPdfUrl
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  }), _vm._v(" Download PDF")])])]), _vm._v(" "), _c('div', {
    staticClass: "details-flex"
  }, [_c('div', {
    staticClass: "ibox ibox-flex"
  }, [_c('div', {
    staticClass: "ibox-content ibox-content-padding-xs"
  }, [_c('ul', {
    staticClass: "invoice-details"
  }, [_c('li', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-md-8"
  }, [_c('p', [_vm._v("\n                      " + _vm._s(_vm.paymentDecorated.carrier_name)), _c('br'), _vm._v("\n                      " + _vm._s(_vm.paymentDecorated.carrier_address)), _c('br'), _vm._v("\n                      " + _vm._s(_vm.paymentDecorated.carrier_suburb) + ", " + _vm._s(_vm.paymentDecorated.carrier_state) + ", " + _vm._s(_vm.paymentDecorated.carrier_postcode) + ","), _c('br'), _vm._v("\n                      Australia\n                    ")])])]), _vm._v(" "), _c('li', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-md-8"
  }, [_c('p', [_vm._v(_vm._s(_vm.paymentDecorated.xero_number))])])]), _vm._v(" "), _c('li', {
    staticClass: "row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-md-8"
  }, [_c('p', [_vm._v(_vm._s(_vm.paymentDecorated.carrier_abn))])])]), _vm._v(" "), _c('li', {
    staticClass: "row"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-md-8"
  }, [_c('p', [_vm._v(_vm._s(_vm.paymentDecorated.created_date_alternative))])])]), _vm._v(" "), _c('li', {
    staticClass: "row"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-md-8"
  }, [_c('p', [_vm._v(_vm._s(_vm.paymentDecorated.paid_date_alternative))])])])])])]), _vm._v(" "), _vm._m(6)]), _vm._v(" "), _c('div', {
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-content ibox-content-padding-xs"
  }, [_c('h3', {
    staticClass: "invoice-single"
  }, [_vm._v("Payment Items")]), _vm._v(" "), _c('ul', {
    staticClass: "list-detail list-detail-invoice-single"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('payment-item', {
      key: index,
      attrs: {
        "item": item,
        "disable-link": true
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-offset-3 col-xs-9 col-sm-offset-7 col-sm-5 col-lg-offset-8 col-lg-4"
  }, [_c('ul', {
    staticClass: "invoice-totals"
  }, [_c('li', [_vm._v("\n                    Subtotal\n                    "), _c('span', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm.paymentDecorated.total_without_gst))])]), _vm._v(" "), _c('li', [_vm._v("\n                    Total GST (10%)\n                    "), _c('span', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm.paymentDecorated.total_gst))])]), _vm._v(" "), _c('li', {
    staticClass: "total"
  }, [_vm._v("\n                    Total AUD\n                    "), _c('span', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm.paymentDecorated.total_with_gst))])]), _vm._v(" "), (_vm.paymentDecorated.hasSomePayments) ? _c('li', [_vm._v("\n                    Payments\n                    "), _c('span', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm.paymentDecorated.paid))])]) : _vm._e(), _vm._v(" "), (_vm.paymentDecorated.hasSomePayments) ? _c('li', {
    staticClass: "total"
  }, [_vm._v("\n                    Amount Due AUD\n                    "), _c('span', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm.paymentDecorated.remaining))])]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-content ibox-content-padding-xs"
  }, [_c('h3', {
    staticClass: "invoice-single"
  }, [_vm._v("Attached Documents")]), _vm._v(" "), _c('ul', {
    staticClass: "file-lists"
  }, _vm._l((_vm.dockets), function(docket) {
    return _c('li', {
      key: docket.id
    }, [_c('a', {
      attrs: {
        "href": _vm.downloadDocketFileUrl(docket.photo_path)
      }
    }, [_c('i', {
      staticClass: "fa fa-file-image-o"
    }), _vm._v(" " + _vm._s(docket.photo_name) + "\n                ")])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "margin-20"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-7 col-lg-7"
  }, [_c('img', {
    staticClass: "payment-logo",
    attrs: {
      "src": "/static/Payment Logo.png",
      "alt": "Arrow Logistics"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 col-md-4"
  }, [_c('p', {
    staticClass: "heading"
  }, [_vm._v("To:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 col-md-4"
  }, [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Payment:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 col-md-4"
  }, [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Reference:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 col-md-4"
  }, [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Issued:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-5 col-md-4"
  }, [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Paid On:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox ibox-flex"
  }, [_c('div', {
    staticClass: "ibox-content ibox-content-padding-xs"
  }, [_c('ul', {
    staticClass: "invoice-details"
  }, [_c('li', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5 col-md-4"
  }, [_c('p', {
    staticClass: "heading"
  }, [_vm._v("From:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-md-8"
  }, [_c('p', [_vm._v("\n                      Arrow Logistics (QLD) Pty Ltd"), _c('br'), _vm._v("\n                      ATF Forster & Borrman Trust"), _c('br'), _vm._v("\n                      PO Box 4796"), _c('br'), _vm._v("\n                      Toowoomba East QLD 4350"), _c('br')])])]), _vm._v(" "), _c('li', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5 col-md-4"
  }, [_c('p', {
    staticClass: "heading"
  }, [_vm._v("ACN:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-md-8"
  }, [_c('p', [_vm._v("119 008 454")])])]), _vm._v(" "), _c('li', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5 col-md-4"
  }, [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Office:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7 col-md-8"
  }, [_c('p', [_vm._v("0455 123 172")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-5b1e1ed6"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/payments/ShowPublic.vue
// module id = 1012
// module chunks = 0